'use strict';

var registerCSSInterfaceWithDefaultTheme = require('../../../../_virtual/registerCSSInterfaceWithDefaultTheme.js_commonjs-exports.js');
var interopRequireDefault = require('../../node_modules/@babel/runtime/helpers/interopRequireDefault.js');
var index = require('../../../react-with-styles-interface-css/index.js');
require('./registerInterfaceWithDefaultTheme.js');
var registerInterfaceWithDefaultTheme = require('../../../../_virtual/registerInterfaceWithDefaultTheme.js_commonjs-exports.js');

(function (exports) {

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerCSSInterfaceWithDefaultTheme;

var _reactWithStylesInterfaceCss = _interopRequireDefault(index);

var _registerInterfaceWithDefaultTheme = _interopRequireDefault(registerInterfaceWithDefaultTheme.__exports);

function registerCSSInterfaceWithDefaultTheme() {
  (0, _registerInterfaceWithDefaultTheme["default"])(_reactWithStylesInterfaceCss["default"]);
}
}(registerCSSInterfaceWithDefaultTheme.__exports));
